var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcAddRing = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#83868A",
  d: "M16 2C8.277 2 2 8.277 2 16s6.277 14 14 14 14-6.277 14-14S23.723 2 16 2m0 25.2C9.828 27.2 4.8 22.172 4.8 16S9.828 4.8 16 4.8 27.2 9.828 27.2 16 22.172 27.2 16 27.2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#83868A",
  d: "M20.725 14.6H17.4v-3.325c0-.77-.63-1.4-1.4-1.4s-1.4.63-1.4 1.4V14.6h-3.325c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4H14.6v3.325c0 .77.63 1.4 1.4 1.4s1.4-.63 1.4-1.4V17.4h3.325c.77 0 1.4-.63 1.4-1.4s-.63-1.4-1.4-1.4"
})));
export default SvgIcAddRing;